<div class="sm:mx-auto sm:w-full sm:max-w-md flex flex-col items-center sticky">
  <img ngSrc="assets/logo.webp" alt="QuickDrive Logo" class="w-24" width="100" height="35" priority />

  <form [formGroup]="authForm" class="w-full p-4 rounded-lg form-container" (ngSubmit)="handleSubmit()">
    <div>
      <ion-input
        appAutofill
        #input
        label="Deine E-Mail"
        [autocomplete]="isSignIn() ? 'email' : null"
        errorText="E-Mail Adresse ungültig"
        label-placement="floating"
        type="email"
        formControlName="email"
        id="email"
        placeholder="name@quickdrive.ch"
        required
      ></ion-input>
    </div>
    <div>
      <ion-input
        appAutofill
        label="Dein Passwort"
        [autocomplete]="isSignIn() ? 'current-password' : null"
        errorText="Passwort ungültig"
        label-placement="floating"
        type="password"
        formControlName="password"
        id="password"
        required
      >
        <ion-input-password-toggle slot="end"></ion-input-password-toggle>
      </ion-input>
    </div>
    <ion-button
      mode="ios"
      class="mb-4 mt-6"
      expand="block"
      type="submit"
      [disabled]="loading()"
      ><ion-label class="flex items-center gap-4"> @if (loading()) {<ion-spinner></ion-spinner>} Login</ion-label></ion-button
    >
    <ion-button
      mode="ios"
      fill="outline"
      expand="block"
      (click)="handleForgotPassword()"
      >Passwort vergessen</ion-button
    >

    <p class="text-center text-sm text-gray-500 mt-10">
      Noch keinen Account?
      <a
        href=""
        class="font-semibold leading-6 text-quickdrive hover:text-blue-800"
        (click)="handleChange($event)"
        >Mit E-Mail registrieren</a
      >
    </p>

  <div class="flex items-center justify-center mt-10 w-full">
    <div class="border-gray-300 border-solid w-1/2 ml-4 dark:border-gray-800"></div>
    <div class="mx-4 text-gray-500">ODER</div>
    <div class="border-gray-300 border-solid w-1/2 mr-4 dark:border-gray-800"></div>
  </div>
  <ion-button
    class="mb-4 mt-10"
    mode="ios"
    fill="outline"
    expand="block"
    color="dark"
    (click)="handleGoogleLogin()"
    ><ion-icon slot="start" name="logo-google"></ion-icon>Mit Google fortfahren</ion-button
  >
  <ion-button
    class="mb-4"
    mode="ios"
    fill="outline"
    expand="block"
    color="dark"
    (click)="handleAppleLogin()"
    ><ion-icon slot="start" name="logo-apple"></ion-icon>Mit Apple fortfahren</ion-button
  >
  <ion-button
    mode="ios"
    fill="outline"
    expand="block"
    color="dark"
    (click)="handleMicrosoftLogin()"
    ><ion-icon slot="start" name="logo-microsoft"></ion-icon>Mit Microsoft fortfahren</ion-button
  >
</form>
</div>
